export default "__VITE_ASSET__5b8915d5__"